import * as React from 'react';

import GenericIconProps from './_icon.type';

function XSquareIcon({ className = 'w-4 h-4 fill-site-neutrals-800' }: GenericIconProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1125_12246)">
        <path d="M22.6643 0H1.33574C0.598033 0 0 0.598033 0 1.33574V22.6643C0 23.402 0.598033 24 1.33574 24H22.6643C23.402 24 24 23.402 24 22.6643V1.33574C24 0.598033 23.402 0 22.6643 0Z" />
        <path d="M18.7018 5.10938H16.4284L4.78125 18.8901H7.05473L18.7018 5.10938Z" fill="white" />
        <path d="M9.14023 5.10938H4.4375L14.8703 18.8901H19.5727L9.14023 5.10938Z" fill="white" />
        <path
          d="M8.44705 6.34375H7.22399C7.16187 6.34375 7.12629 6.41492 7.16374 6.46456L15.4791 17.5042C15.4935 17.5232 15.5157 17.5342 15.5394 17.5342H16.7624C16.8246 17.5342 16.8601 17.463 16.8227 17.4133L8.50729 6.37372C8.49293 6.35468 8.47077 6.34375 8.44705 6.34375Z"
          strokeWidth="0.0312163"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_1125_12246">
          <rect width="24" height="24" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default XSquareIcon;
